/** Prefix for CardFinder exclusive-modal claims on the Compass overlay bus. */
export const CARDFINDER_OVERLAY_OWNER_PREFIX = 'cardfinder-modal:';
